import React, { useEffect, useRef } from 'react';
import { HeaderContainer } from '@app/shell/SiteHeader/shared/components/HeaderContainer';
import useIsMobileAppView from '@app/shell/hooks/useIsMobileAppView';
import { useIsNonInteractiveViewer } from '@app/ui';
import { useDispatch } from 'react-redux';
import { setNavbarHeight } from '@app/redux/ui/actions';
import InlineNotification from './components/InlineNotification';
import Content from './components/Content';
import Navigation from './components/Navigation';

const StaticHeader = () => (
  <HeaderContainer>
    <Content />
    <Navigation />
  </HeaderContainer>
);

const SiteHeader = () => {
  const isMobileAppView = useIsMobileAppView();
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setNavbarHeight(ref.current?.offsetHeight ?? 0));
  }, [dispatch, ref?.current?.offsetHeight]);

  if (isMobileAppView) {
    return null;
  }

  return (
    <HeaderContainer>
      <span ref={ref}>
        <InlineNotification />
        <Content />
        <Navigation />
      </span>
    </HeaderContainer>
  );
};

const Header = () => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();

  if (isNonInteractiveViewer) {
    return <StaticHeader />;
  }

  return <SiteHeader />;
};

export default Header;
